import { render, staticRenderFns } from "./NotAvailableOnMobile.vue?vue&type=template&id=690db83a&scoped=true"
import script from "./NotAvailableOnMobile.vue?vue&type=script&lang=js"
export * from "./NotAvailableOnMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690db83a",
  null
  
)

export default component.exports